import React, { Component } from 'react';
import { api_url, headers } from '../../common/config';
import { Link } from 'react-router-dom';
import i18next from 'i18next';
class ArticleCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            image: null,
        };
    }

    componentDidMount() {
        this.getImage();
    }

    getImage = () => {
        if (this.props.image !== undefined) {
            fetch(`${api_url}/autism/files/${this.props.image}`, {
                method: 'GET',
                // headers: headers,
            })
                .then((res) => res.json())
                .then((res) => {
                    this.setState({
                        image: res.data.data.full_url,
                    });
                });
        } else {
            // Do nothing
        }
    };

    render() {
        return (
            <div className='articles_card'>
                <div
                    className={`card_image ${
                        i18next.language === 'en' ? 'en_card_image' : ''
                    }`}
                    style={{
                        backgroundImage: `url(${this.state.image})`,
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center',
                    }}
                ></div>
                <Link to={`/blog/article/${this.props.id}`} replace>
                    <div className='card_content'>
                        <p>{this.props.name}</p>
                        <h2>{this.props.title}</h2>
                        <h3>{this.props.subtitle}</h3>
                    </div>
                </Link>
            </div>
        );
    }
}

export default ArticleCard;
